import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from 'models/field.interface';
import { UtilityService } from 'services';

@Component({
  templateUrl: './radio.component.html'
})
export class RadiobuttonComponent {
  field: FieldConfig;
  group: FormGroup;
  constructor(private util: UtilityService) { }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
  getValidationMessage(val) {
    if (val === 'required') {
      return 'This field is required.';
    }
    return 'Invalid';
  }
}
